import {
  AuthType,
  CloudAccountType,
} from '@internal/backstage-plugin-catalog-devops-common';
import { ModernSelect } from '@internal/backstage-plugin-devops-react';

interface AccountAuthTypeInputProps {
  accountType: CloudAccountType;
  accountAuthType: AuthType;
  setAccountAuthType: (accountAuthType: AuthType) => void;
  isInvalid?: boolean;
  disabled?: boolean;
}

export const AccountAuthTypeInput = (props: AccountAuthTypeInputProps) => {
  const {
    accountType,
    accountAuthType,
    setAccountAuthType,
    isInvalid,
    disabled,
  } = props;

  const options =
    accountType === CloudAccountType.AWS
      ? [
          { label: 'AWS_ACCESS_KEY', value: AuthType.AWS_ACCESS_KEY },
          {
            label: 'AWS_INSTANCE_PROFILE',
            value: AuthType.AWS_INSTANCE_PROFILE,
          },
        ]
      : [{ label: 'LOAD_AZURE', value: AuthType.LOAD_AZURE }];

  return (
    <ModernSelect
      label="Authentication Type"
      options={options}
      value={accountAuthType}
      onChange={value => setAccountAuthType(value as AuthType)}
      isInvalid={isInvalid}
      isDisabled={disabled}
      isRequired
    />
  );
};
